export const InsuranceCompanyList = [
  '',
  'AIA',
  'AXA',
  'CPF',
  'Great Eastern Life',
  'NTUC Income',
  'Prudential',
  'Raffles Health',
  'Singlife with Aviva',
  'AIG',
  'Aetna',
  'Allianz',
  'Allied World',
  'China Life',
  'China Taiping',
  'Chubb',
  'Cigna',
  'Direct Asia',
  'Etiqa',
  'FWD',
  'Friends Provident',
  'HL Assurance',
  'HSBC Life',
  'LIC',
  'Liberty',
  'MSIG',
  'Manulife',
  'QBE',
  'Quilter',
  'Health',
  'Sompo',
  'Sun Life',
  'Swiss Life',
  'Tokio Marine',
  'Transamerica',
  'UOI',
  'Utmost',
  'Zurich'
]
